jQuery(document).ready(function($) {

    // HDP
    var h1 = $(".bloc_hdp h1")
    var logo = $("#header .logo img")
    var contact = $("#header .contact")
    var hdp = $(".bloc_hdp")
    var logoFiliale = $(".bloc_hdp .logo img")
    var chapeau = $(".bloc_hdp .chapeau")
    var more = $(".bloc_hdp .more span")
    var filet = $(".bloc_hdp .more .filet")
    var detail = $(".bloc_hdp .detail")
    var btn = $(".bloc_hdp .btn")
    var pager = $(".hdp .pager")


    // Encart contact toggle
    var encartContact = $(".encart_contact")
    var encartToggle = $(".encart_contact_toggle")

    if(encartToggle.length){
        encartToggle.on("click", function(){
            encartContact.toggleClass("open")
        })
    }

    var splitWordsH1 = new SplitText( h1 , {
        type: "words",
        tag:'div',
        reduceWhiteSpace:true,
        wordsClass: "word++"
    })

    var splitCharsH1 = new SplitText( h1 , {
        type: "chars",
        tag:'span',
        //reduceWhiteSpace:true,
        //mask: "chars",
        charsClass: "char++"
    })

    var hdpTL = gsap.timeline()

    /*

    gsap.set(hdp, { clipPath: 'polygon(25% 25%, 25% 25%, 25% 75%, 25% 75%)' })


    if(hdp.length){
        hdpTL.to(hdp, {
            clipPath: 'polygon(25% 25%, 75% 25%, 75% 75%, 25% 75%)',
            duration : 1.4,
            delay: 0.3,
            ease: "power1.out",
        })

        hdpTL.to(hdp, {
            clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
            duration : 1.4,
            delay: 1.0,
            ease: "power1.out",
        })
    }
    */

    if(logoFiliale.length){
        hdpTL.from(logoFiliale, {
            opacity:0,
            duration: 0.5,
            ease: "power1.out",
        })
    }

    if(h1.length){
        hdpTL.from(splitWordsH1.words, {
            opacity: 0,
            rotation: -2,
            stagger: .05,
            duration: 0.5,
            ease: "power1.out",
        })
    }

    if(chapeau.length){
        hdpTL.from(chapeau, {
            opacity : 0,
            duration : 0.3,
            delay: 0.1,
            ease: "power1.out",
        })
    }

    if(detail.length) {
        hdpTL.from(detail, {
            opacity: 0,
            duration: 0.3,
            delay: 0.1,
            ease: "power1.out",
        })
    }

    if(btn.length) {
        hdpTL.from(btn, {
            opacity: 0,
            duration: 0.3,
            delay: 0.1,
            ease: "power1.out",
        })
    }

    if(encartContact.length) {
        hdpTL.from(encartContact, {
            x: 100,
            opacity: 0,
            duration: 0.3,
            delay: 0.1,
            ease: "power1.out",
        })
    }

    if(logo.length) {
        hdpTL.from(logo, {
            opacity: 0,
            duration: 0.3,
            delay: 0.1,
            ease: "power1.out",
        })
    }

    if(contact.length) {
        hdpTL.from(contact, {
            opacity: 0,
            duration: 0.3,
            delay: 0,
            ease: "power1.out",
        })
    }

    if(filet.length) {
        hdpTL.from(filet, {
            height: 0,
            duration: 0.2,
            delay: 0,
            ease: "power1.out",
        })
    }

    if(more.length) {
        hdpTL.from(more, {
            opacity: 0,
            duration: 0.2,
            delay: 0,
            ease: "power1.out",
        })
    }

    if(pager.length) {
        hdpTL.from(pager, {
            x: -100,
            duration: 0.2,
            delay: 0,
            ease: "power1.out",
        })
    }

});